import React, { useState } from 'react';
import { cleanMobile, mobileError } from '../../utils/phone';
import { inputClass as defaultInputClass } from './formClasses';

// A mobile-number field: "+91" is always shown, only digits can be typed (a pasted "+91 98765 43210" is trimmed to its
// 10 digits) and the person is told at once when the number cannot be right.
//
//   value      the 10 digits (or fewer while typing), no spaces, no "+91"
//   onChange   called with the cleaned digits, not the event
//   showErrors show "too short / empty" now (e.g. after pressing Continue); it is also shown once they leave the field
const PhoneInput = ({
  id,
  value,
  onChange,
  showErrors = false,
  inputClassName = defaultInputClass,
  prefixClassName = 'border-brand-border/70 bg-canvas text-brand-muted',
  className = '',
  placeholder = '10-digit mobile number',
  autoFocus,
  disabled,
  required,
  onBlur,
}) => {
  const [left, setLeft] = useState(false);
  const error = mobileError(value, { finished: showErrors || left });
  const errorId = `${id}-error`;

  return (
    <div className={className}>
      <div className="flex">
        <span
          className={`flex select-none items-center rounded-none border border-r-0 px-4 text-[15px] ${prefixClassName}`}
          aria-hidden="true"
        >
          +91
        </span>
        <input
          id={id}
          className={`${inputClassName} min-w-0 flex-1`}
          type="tel"
          inputMode="numeric"
          autoComplete="tel-national"
          placeholder={placeholder}
          value={value}
          onChange={(event) => onChange(cleanMobile(event.target.value))}
          onBlur={(event) => {
            setLeft(true);
            if (onBlur) onBlur(event);
          }}
          aria-label="Mobile number, India (+91)"
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={error ? errorId : undefined}
          autoFocus={autoFocus}
          disabled={disabled}
          required={required}
        />
      </div>
      {error && (
        <p id={errorId} className="mt-1.5 text-xs text-oxblood" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default PhoneInput;
